(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function store(k, v) {
    try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; }
    return null;
  }

  // Maquette uniquement : les animations sont forcées pour la démonstration.
  // Dans le thème Shopify, le réglage « réduire les animations » du visiteur est respecté.
  var MAQUETTE = false;
  // #anim force les animations sur cet appareil (vérification), #noanim revient au réglage du système
  if (/noanim/.test(location.hash)) store('sz-motion', 'system'); else if (/anim/.test(location.hash)) store('sz-motion', 'force');
  var force = store('sz-motion') !== 'system';
  // Lien « Réduire les animations » du pied de page : le choix du visiteur est mémorisé
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-motion-toggle]'); if (!b) return;
    store('sz-motion', force ? 'system' : 'force'); location.reload();
  });
  doc.addEventListener('DOMContentLoaded', function () {
    $$('[data-motion-toggle]').forEach(function (b) { b.textContent = force ? 'Réduire les animations' : 'Réactiver les animations'; b.setAttribute('aria-pressed', force ? 'false' : 'true'); });
  });
  if (force) root.classList.add('force-motion');
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches && !force;

  // ===== Prix : identiques à Shopify (69,99 €, lot de 2 à −15 %, lot de 3 et plus à −20 %) =====
  var SZ = window.SZ || {}, UNIT = +SZ.unit || 0, COMPARE = +SZ.compare || 0, IMG = SZ.img || '', ROOT = (SZ.root || '/').replace(/\/$/, ''), PRODUCT = SZ.product || '/products/handrelax';
  function disc(q) { return q >= 3 ? 20 : q === 2 ? 15 : 0; }
  function total(q) { return Math.round(q * UNIT * (100 - disc(q)) / 100); }
  var NF = new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'});
  function eur(c) { return NF.format(c / 100); }

  // ===== Urgence réelle : heure de Paris, jours ouvrés, jours fériés =====
  var FER = ['2026-01-01','2026-04-06','2026-05-01','2026-05-08','2026-05-14','2026-05-25','2026-07-14','2026-08-15','2026-11-01','2026-11-11','2026-12-25',
             '2027-01-01','2027-03-29','2027-05-01','2027-05-06','2027-05-08','2027-05-17','2027-07-14','2027-08-15','2027-11-01','2027-11-11','2027-12-25'];
  function paris() {
    var o = {};
    new Intl.DateTimeFormat('en-CA', {timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'}).formatToParts(new Date())
      .forEach(function (x) { o[x.type] = x.value; });
    return {d: new Date(Date.UTC(+o.year, +o.month - 1, +o.day)), h: +o.hour % 24, m: +o.minute, s: +o.second};
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function ouvre(d) { var w = d.getUTCDay(); return w > 0 && w < 6 && FER.indexOf(iso(d)) < 0; }
  function plus(d, n) { d = new Date(d); while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); if (ouvre(d)) n--; } return d; }
  var fmt = new Intl.DateTimeFormat('fr-FR', {weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC'});
  var fmtS = new Intl.DateTimeFormat('fr-FR', {day: 'numeric', month: 'short', timeZone: 'UTC'});
  function pt(s) { return /\.$/.test(s) ? s : s + '.'; }
  var XMAS = Date.UTC(2026, 11, 10), NOEL = Date.UTC(2026, 11, 24);
  function tick() {
    var p = paris(), avant = p.h < 18, aujourdhui = ouvre(p.d) && avant, msg, light;
    if (aujourdhui) {
      var reste = 18 * 3600 - (p.h * 3600 + p.m * 60 + p.s), hh = Math.floor(reste / 3600), mm = Math.floor(reste % 3600 / 60);
      var duree = (hh ? hh + ' h ' : '') + mm + ' min';
      msg = 'Commandez dans <b>' + duree + '</b>, préparé aujourd’hui.';
      light = 'Commandez dans <b>' + duree + '</b> et votre colis est préparé aujourd’hui.';
    } else {
      var j = fmt.format(plus(p.d, 1));
      msg = 'Commandé maintenant, préparé <b>' + j + '</b>' + (/\.$/.test(j) ? '' : '.');
      light = 'Commandé maintenant, votre colis est préparé <b>' + j + '</b>' + (/\.$/.test(j) ? '' : '.');
    }
    $$('[data-cutoff]').forEach(function (e) { e.innerHTML = msg; });
    $$('[data-cutoff-light]').forEach(function (e) { e.innerHTML = light; });
    var a = plus(p.d, 5), b = plus(p.d, 10);
    $$('[data-eta]').forEach(function (e) { e.textContent = pt('Livré entre le ' + fmt.format(a) + ' et le ' + fmt.format(b)); });
    var jours = Math.round((XMAS - p.d.getTime()) / 864e5);
    $$('[data-xmas]').forEach(function (x) {
      if (jours > 1) x.textContent = 'Encore ' + jours + ' jours pour un cadeau livré avant Noël.';
      else if (jours === 1) x.textContent = 'Plus que demain pour un cadeau livré avant Noël.';
      else if (jours === 0 && avant) x.textContent = 'Dernier jour : commandez avant 18 h.';
      else x.textContent = 'Commandé aujourd’hui, il arrivera après le 25 décembre.';
    });
    $$('[data-xmas-short]').forEach(function (x) {
      var on = jours > 0 || (jours === 0 && avant);
      x.hidden = !on; if (!on) return;
      x.innerHTML = 'Pour Noël, commandez avant le <b>10 déc., 18 h</b> : ' + (jours > 1 ? 'encore ' + jours + ' jours.' : jours === 1 ? 'plus que demain.' : 'dernier jour.') + (x.closest('.bb') ? ' <a href="offrir.html">Offrir HandRelax</a>' : '');
    });
    // Frise : aujourd'hui → 10 déc. → 24 déc.
    var tl = $('[data-timeline]');
    if (tl) {
      var span = NOEL - p.d.getTime(), cut = Math.max(0, Math.min(1, (XMAS - p.d.getTime()) / span));
      if (span <= 0) cut = 0;
      var c = $('.cut', tl); if (c) c.style.left = (cut * 100) + '%';
      var bar = $('i', tl); if (bar) bar.style.transform = 'scaleX(' + (tl.classList.contains('seen') ? cut : 0) + ')';
      var t = $('[data-today]'); if (t) t.textContent = pt(fmtS.format(p.d));
    }
  }
  tick(); setInterval(tick, 30000);
  function two(n) { return (n < 10 ? '0' : '') + n; }
  function tickS() {
    var p = paris(), c = null;
    if (ouvre(p.d) && p.h < 18) { var r = 18 * 3600 - (p.h * 3600 + p.m * 60 + p.s); c = [Math.floor(r / 3600), Math.floor(r % 3600 / 60), r % 60]; }
    $$('[data-urg]').forEach(function (e) {
      var t = $('[data-urg-t]', e); if (!t) return;
      if (c) t.innerHTML = 'Commandez dans <b class="num">' + (c[0] ? c[0] + ' h ' : '') + two(c[1]) + ' min ' + two(c[2]) + ' s</b> : votre colis part en préparation aujourd’hui.';
      else t.innerHTML = 'Commandé maintenant, votre colis est préparé <b>' + pt(fmt.format(plus(p.d, 1))) + '</b>';
      e.classList.toggle('today', !!c);
    });
    $$('[data-obar-cd]').forEach(function (e) { e.textContent = c ? ' · préparé aujourd’hui, encore ' + (c[0] ? c[0] + ' h ' : '') + c[1] + ' min' : ' · Livraison offerte'; });
  }
  tickS(); setInterval(tickS, 1000);

  // ===== Formulaires d'offre (lots 1, 2, 3) =====
  $$('form[data-offer]').forEach(function (f) {
    var out = $('[data-total]', f);
    function upd() {
      var r = $('input[type=radio]:checked', f); if (!r || !out) return;
      var q = +r.value, rr = q >= 3 ? +(f.dataset.r3 || 20) : q === 2 ? +(f.dataset.r2 || 15) : 0;
      out.textContent = eur(q * (UNIT - Math.floor(UNIT * rr / 100)));
      // Prix initial barré du total : prix comparé Shopify × quantité, masqué s'il n'est pas renseigné
      var was = $('[data-total-was]', f);
      if (was) { was.hidden = !(COMPARE > UNIT); was.textContent = eur(+r.value * COMPARE); }
      if (!reduce) { out.classList.remove('tick'); void out.offsetWidth; out.classList.add('tick'); }
    }
    $$('input[type=radio]', f).forEach(function (r) { r.addEventListener('change', upd); });
    upd();
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var r = $('input[type=radio]:checked', f), q = r ? +r.value : 1, btn = $('button[type=submit]', f);
      if (btn) btn.setAttribute('aria-busy', 'true');
      add(q).then(function () {
        if (btn) { btn.removeAttribute('aria-busy'); var t = btn.textContent; btn.textContent = 'Ajouté au panier'; setTimeout(function () { btn.textContent = t; }, 1600); }
        openDrawer($('#cart'), btn);
      }, function (er) {
        if (btn) btn.removeAttribute('aria-busy');
        note = (er && er.description) || 'L’ajout au panier n’a pas abouti. Réessayez dans un instant.';
        openDrawer($('#cart'), btn); note = '';
      });
    });
  });

  // Liens « Passer au lot de 2 » : présélectionnent le lot dans le formulaire de la page
  doc.addEventListener('click', function (e) {
    var a = e.target.closest('[data-pick]'); if (!a) return;
    var f = $('form[data-offer]'); if (!f) return;
    var r = $('input[value="' + a.getAttribute('data-pick') + '"]', f);
    if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', {bubbles: true})); }
  });

  // ===== Panier Shopify (API Ajax) : le tiroir et la page panier partagent le même contenu =====
  var cart = {items: [], item_count: 0, total_price: 0, original_total_price: 0, cart_level_discount_applications: []};
  var note = '', undo = null;
  function api(path, body) {
    var o = body ? {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)} : {headers: {Accept: 'application/json'}};
    return fetch(ROOT + path, o).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function busy(on) { $$('[data-cart-body],[data-cart-foot]').forEach(function (x) { if (on) x.setAttribute('aria-busy', 'true'); else x.removeAttribute('aria-busy'); }); }
  function refresh(bump) { return api('/cart.js').then(function (c) { cart = c; render(bump); }); }
  function add(n) { undo = null; busy(true); return api('/cart/add.js', {items: [{id: SZ.variant, quantity: n}]}).then(function () { return refresh(true); }).finally(function () { busy(false); }); }
  function setLine(key, q) { busy(true); return api('/cart/change.js', {id: key, quantity: q}).then(function (c) { cart = c; render(true); }).catch(function (er) { note = (er && er.description) || 'La mise à jour du panier n’a pas abouti.'; render(false); note = ''; }).finally(function () { busy(false); }); }
  function mainLine() { return cart.items.filter(function (i) { return i.variant_id == SZ.variant; })[0]; }
  function setLot(n) { var l = mainLine(); return l ? setLine(l.key, n) : add(n); }
  function stack(n) { var h = ''; for (var i = 0; i < n; i++) h += '<span><img alt="" src="' + IMG + '"></span>'; return '<span class="stack" aria-hidden="true">' + h + '</span>'; }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]; }); }
  function discTitle() {
    var t = (cart.cart_level_discount_applications || [])[0];
    if (t) return t.title;
    var found = '';
    cart.items.some(function (i) { return (i.line_level_discount_allocations || []).some(function (a) { found = a.discount_application && a.discount_application.title; return !!found; }); });
    return found || 'Remise';
  }
  function render(bump) {
    var qty = cart.item_count || 0;
    $$('[data-cart-count]').forEach(function (e) {
      e.textContent = qty;
      if (bump && !reduce) { e.classList.remove('bump'); void e.offsetWidth; e.classList.add('bump'); }
    });
    $$('[data-open-cart]').forEach(function (b) { b.setAttribute('aria-label', 'Ouvrir le panier, ' + (qty ? qty + (qty > 1 ? ' articles' : ' article') : 'vide')); });
    $$('[data-cart-n]').forEach(function (n) { n.textContent = qty ? '(' + qty + ')' : ''; });
    var bodies = $$('[data-cart-body]'), feet = $$('[data-cart-foot]');
    $$('[data-cart-side]').forEach(function (x) { x.hidden = !qty; });
    if (!qty) {
      bodies.forEach(function (b) { b.innerHTML = '<div class="empty"><p>Votre panier est vide.</p>' + (undo ? '<p class="undo" role="status">L’article a été retiré. <button class="link rm" type="button" data-undo>Annuler</button></p>' : '') + (note ? '<p class="dr-err" role="alert">' + esc(note) + '</p>' : '') + '<a class="btn btn-primary alive" href="' + PRODUCT + '">Découvrir HandRelax</a></div>'; });
      feet.forEach(function (f) { f.innerHTML = ''; f.hidden = true; });
      return;
    }
    var full = cart.original_total_price, t = cart.total_price, dsc = full - t, ml = mainLine(), mq = ml ? ml.quantity : 0;
    var up = '';
    if (mq === 1) up = '<div class="upsell">' + stack(2) + '<p><b>Un second à offrir ?</b> Au lot de 2, chaque masseur revient à ' + eur(UNIT - Math.floor(UNIT * 15 / 100)) + ', soit ' + eur(2 * Math.floor(UNIT * 15 / 100)) + ' d’économie.</p><button class="btn btn-ghost-dark" type="button" data-set="2">Passer au lot de 2</button></div>';
    if (mq === 2) up = '<div class="upsell">' + stack(3) + '<p><b>Pour la famille ?</b> Au lot de 3, chaque masseur revient à ' + eur(UNIT - Math.floor(UNIT * 20 / 100)) + ', soit ' + eur(3 * Math.floor(UNIT * 20 / 100)) + ' d’économie.</p><button class="btn btn-ghost-dark" type="button" data-set="3">Passer au lot de 3</button></div>';
    var lines = cart.items.map(function (i) {
      var mine = i.variant_id == SZ.variant;
      var img = mine ? IMG : (i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : IMG);
      var name = esc(String(i.product_title).split(/ — |, /)[0]);
      var sub = i.quantity > 1 && i.final_line_price < i.original_line_price ? 'Lot de ' + i.quantity + ' · ' + eur(Math.round(i.final_line_price / i.quantity)) + ' pièce' : (mine ? 'Masseur cervical chauffant' : esc(i.variant_title || ''));
      return '<li class="item"><img src="' + img + '" alt="" width="80" height="80">' +
        '<div class="it-t"><b>' + name + '</b>' + (mine ? rateHTML() : '') + '<span class="num">' + sub + '</span>' +
        '<div class="qty" role="group" aria-label="Quantité"><button type="button" data-q="-1" data-key="' + i.key + '" aria-label="Retirer un article"' + (i.quantity <= 1 ? ' disabled' : '') + '>−</button><output class="num" aria-live="polite">' + i.quantity + '</output><button type="button" data-q="1" data-key="' + i.key + '" aria-label="Ajouter un article"' + (i.quantity >= 10 ? ' disabled' : '') + '>+</button></div></div>' +
        '<div class="it-p num">' + (mine && COMPARE > UNIT ? '<s>' + eur(i.quantity * COMPARE) + '</s>' : i.final_line_price < i.original_line_price ? '<s>' + eur(i.original_line_price) + '</s>' : '') + '<b>' + eur(i.final_line_price) + '</b><button class="rm" type="button" data-rm data-key="' + i.key + '">Retirer</button></div></li>';
    }).join('');
    var bodyHTML =
      cdHTML() +
      '<ul class="items">' + lines + '</ul>' + up;
    var footHTML =
      '<dl class="sum num sz-prix"><div><dt>Sous-total</dt><dd>' + wasHTML(mq) + eur(full) + '</dd></div>' +
      (dsc > 0 ? '<div><dt>' + esc(discTitle()) + '</dt><dd>−' + eur(dsc) + '</dd></div>' : '') +
      '<div><dt>Livraison</dt><dd>Offerte</dd></div><div class="tot"><dt>Total</dt><dd' + (bump && !reduce ? ' class="tick"' : '') + '>' + wasHTML(mq) + eur(t) + '</dd></div></dl>' +
      (note ? '<p class="dr-err" role="alert">' + esc(note) + '</p>' : '') +
      '<button class="btn btn-primary num alive" type="button" data-checkout>Passer au paiement<span class="sep" aria-hidden="true"></span>' + wasHTML(mq) + eur(t) + '</button>' +
      payHTML() + '<p class="fine">Carte bancaire, PayPal, Apple Pay, Shop Pay</p>' +
      '<p class="more only-drawer"><a href="' + ROOT + '/cart">Voir le panier détaillé</a></p>';
    bodies.forEach(function (b) { b.innerHTML = bodyHTML; });
    feet.forEach(function (f) { f.innerHTML = footHTML; f.hidden = false; });
    tick(); tickS();
  }
  doc.addEventListener('click', function (e) {
    var t = e.target.closest('[data-q],[data-rm],[data-undo],[data-set],[data-checkout],[data-open-cart],[data-open-menu],[data-close],[data-scrim]');
    if (!t) return;
    var sc = t.closest('.drawer,.cartp') || doc;
    function foc(sel) { var x = $(sel, sc); if (x) x.focus(); }
    function line(k) { return cart.items.filter(function (i) { return i.key === k; })[0]; }
    if (t.hasAttribute('data-q')) { var l = line(t.getAttribute('data-key')); if (l) setLine(l.key, l.quantity + +t.getAttribute('data-q')).then(function () { foc('.qty button:not([disabled])'); }); }
    else if (t.hasAttribute('data-rm')) { var l2 = line(t.getAttribute('data-key')); if (l2) { undo = {id: l2.variant_id, quantity: l2.quantity}; setLine(l2.key, 0).then(function () { foc('[data-undo]'); }); } }
    else if (t.hasAttribute('data-undo')) { var u = undo; undo = null; if (u) { busy(true); api('/cart/add.js', {items: [u]}).then(function () { return refresh(true); }).finally(function () { busy(false); foc('.qty button:not([disabled])'); }); } }
    else if (t.hasAttribute('data-set')) { setLot(+t.getAttribute('data-set')).then(function () { foc('.qty button:not([disabled])'); }); }
    else if (t.hasAttribute('data-checkout')) { t.setAttribute('aria-busy', 'true'); location.href = ROOT + '/checkout'; }
    else if (t.hasAttribute('data-open-cart')) { openDrawer($('#cart'), t); refresh(false); }
    else if (t.hasAttribute('data-open-menu')) openDrawer($('#menu'), t);
    else closeDrawer();
  });

  // ===== Tiroirs (panier, menu) : piège du focus, Échap, retour du focus =====
  var scrim = $('[data-scrim]'), openEl = null, lastFocus = null;
  function openDrawer(el, from) {
    if (!el) return;
    if (openEl && openEl !== el) closeDrawer(true);
    lastFocus = from || doc.activeElement; openEl = el;
    if (el.id === 'cart') render(false);
    scrim.hidden = false; el.hidden = false; root.classList.add('locked');
    if (!reduce) { el.classList.add('entering'); setTimeout(function () { el.classList.remove('entering'); }, 900); }
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('open'); scrim.classList.add('open'); }); });
    setTimeout(function () { if (!el.classList.contains('open')) { el.classList.add('open'); scrim.classList.add('open'); } }, 60);
    var f = $('[data-close]', el); if (f) f.focus({preventScroll: true});
  }
  function closeDrawer(silent) {
    if (!openEl) return;
    var el = openEl; openEl = null;
    el.classList.remove('open'); scrim.classList.remove('open'); root.classList.remove('locked');
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { if (openEl !== el) { el.hidden = true; if (!openEl) scrim.hidden = true; } }, reduce ? 0 : 320);
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({preventScroll: true});
  }
  doc.addEventListener('keydown', function (e) {
    if (!openEl) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('a[href],button:not([disabled]),input,textarea,select,[tabindex]:not([tabindex="-1"])', openEl).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  render(false); refresh(false);
  // Retour arrière du navigateur : le panier est relu
  addEventListener('pageshow', function (e) { if (e.persisted) refresh(false); });

  // ===== Galerie de la fiche produit =====
  var gal = $('[data-gal]');
  if (gal) {
    var track = $('.gal-main', gal), thumbs = $$('.gal-thumbs button', gal), idx = $('[data-gal-i]', gal);
    function cur() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function mark(i) { thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); }); if (idx) idx.textContent = i + 1; }
    var raf = 0;
    track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; mark(cur()); }); }, {passive: true});
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { track.scrollTo({left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth'}); mark(i); }); });
    mark(0);
  }

  // ===== Compte à rebours jusqu'à minuit, heure de Paris : repart tout seul chaque jour, rien n'est stocké =====
  var CDC = (window.SZ || {}).cd || {on: true, t: 'L’offre expire à la fin de la journée', a: 'Prix barré et livraison offerte jusqu’à minuit.'};
  // Note des avis Judge.me et icônes des moyens de paiement (fournis par le thème), affichés dans le panier
  var SZD = window.SZ || {}, RT = SZD.rating || {r: 4.8, n: 82};
  function rateHTML() {
    if (!(+RT.n > 0)) return '';
    var st = '', P = '<path d="m12 2.8 2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17.2l-5.7 3.1 1.2-6.4-4.7-4.4 6.4-.8z"/>';
    for (var i = 1; i <= 5; i++) st += '<svg viewBox="0 0 24 24" aria-hidden="true"' + (i > Math.round(+RT.r) ? ' class="off"' : '') + '>' + P + '</svg>';
    return '<a class="it-rate num" href="' + (typeof PRODUCT !== 'undefined' ? PRODUCT : PRODUCT) + '#avis" aria-label="Note ' + String((+RT.r).toFixed(1)).replace('.', ',') + ' sur 5, ' + RT.n + ' avis"><span class="stars" aria-hidden="true">' + st + '</span><span>' + String((+RT.r).toFixed(1)).replace('.', ',') + ' · ' + RT.n + ' avis</span></a>';
  }
  function wasHTML(q) { return COMPARE > UNIT ? '<s class="was">' + eur(q * COMPARE) + '</s> ' : ''; }
  function payHTML() { return SZD.pay ? '<div class="pay-ics" aria-label="Moyens de paiement acceptés">' + SZD.pay + '</div>' : ''; }
  function cdHTML() {
    if (!CDC.on) return '';
    var u = function (k, l) { return '<span class="sz-cd-u"><b data-' + k + '>00</b><small>' + l + '</small></span>'; };
    return '<div class="sz-cd" data-sz-cd>' + (CDC.t ? '<p class="sz-cd-t">' + CDC.t + '</p>' : '') +
      '<div class="sz-cd-n num" role="timer" aria-label="Temps restant avant minuit">' + u('h', 'h') + '<i aria-hidden="true">:</i>' + u('m', 'min') + '<i aria-hidden="true">:</i>' + u('s', 's') + '</div>' +
      (CDC.a ? '<p class="sz-cd-a">' + CDC.a + '</p>' : '') + '</div>';
  }
  {
    var cdFmt = new Intl.DateTimeFormat('fr-FR', {timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'});
    var cd2 = function (n) { return (n < 10 ? '0' : '') + n; };
    var cdTick = function () {
      var p = {};
      cdFmt.formatToParts(new Date()).forEach(function (x) { p[x.type] = +x.value; });
      var r = (86400 - ((p.hour % 24) * 3600 + p.minute * 60 + p.second)) % 86400;
      var h = Math.floor(r / 3600), m = Math.floor(r % 3600 / 60), sec = r % 60;
      $$('[data-sz-cd]').forEach(function (c) {
        $('[data-h]', c).textContent = cd2(h); $('[data-m]', c).textContent = cd2(m); $('[data-s]', c).textContent = cd2(sec);
        $('[role=timer]', c).setAttribute('aria-label', 'Encore ' + h + ' h ' + m + ' min ' + sec + ' s avant minuit');
      });
      setTimeout(cdTick, 1000 - Date.now() % 1000 + 20);
    };
    cdTick();
  }

  // ===== Aide : recherche dans les questions =====
  var q = $('#q-aide');
  if (q) {
    var res = $('#q-res'), none = $('#q-none'), noneT = $('#q-none-t');
    var items = $$('.aide-sec details').map(function (d) {
      var s = $('summary', d);
      return {d: d, sec: d.closest('.aide-sec'), s: s, label: s.firstChild.nodeValue, txt: norm(d.textContent)};
    });
    function norm(s) { return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[’']/g, ' '); }
    function esc(s) { return s.replace(/[&<>"]/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]; }); }
    q.addEventListener('input', function () {
      var v = norm(q.value.trim()), words = v.split(/\s+/).filter(function (w) { return w.length > 1; }), n = 0;
      items.forEach(function (it) {
        var ok = !words.length || words.every(function (w) { return it.txt.indexOf(w) >= 0; });
        it.d.hidden = !ok; if (ok) n++;
        it.d.classList.remove('pre');
        it.d.open = !!(ok && words.length && n <= 3);
      });
      $$('.aide-sec').forEach(function (s) { s.hidden = !!words.length && !$$('details:not([hidden])', s).length; });
      res.textContent = words.length ? (n ? n + (n > 1 ? ' réponses trouvées' : ' réponse trouvée') : 'Aucune réponse') : '';
      if (!reduce) { res.classList.remove('tick'); void res.offsetWidth; res.classList.add('tick'); }
      none.hidden = !(words.length && !n);
      if (noneT) noneT.textContent = q.value.trim();
    });
  }

  // ===== Contact : validation à la sortie du champ, récapitulatif des erreurs, confirmation =====
  var cf = $('#cform');
  var sentOk = $('#sent'); if (sentOk) sentOk.focus();
  if (cf && $('input', cf)) {
    var rules = {
      nom: function (v) { return v ? '' : 'Indiquez votre nom.'; },
      email: function (v) { return !v ? 'Indiquez votre adresse e-mail.' : (/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) ? '' : 'Cette adresse e-mail semble incomplète. Vérifiez qu’elle contient un @ et un domaine, par exemple nom@exemple.fr.'); },
      commande: function (v) { return !v || /^#?\d{3,8}$/.test(v) ? '' : 'Le numéro de commande contient seulement des chiffres, par exemple #1001.'; },
      message: function (v) { return v.length >= 10 ? '' : (v ? 'Votre message est un peu court : 10 caractères au minimum.' : 'Écrivez votre message.'); }
    };
    function check(el) {
      var m = rules[el.dataset.rule || el.name](el.value.trim()), f = el.closest('.field'), box = $('.msg', f);
      f.classList.toggle('err', !!m); el.setAttribute('aria-invalid', m ? 'true' : 'false');
      box.textContent = m; box.hidden = !m; return m;
    }
    $$('input:not([type=hidden]),textarea', cf).forEach(function (el) {
      el.addEventListener('blur', function () { if (el.value.trim() || el.getAttribute('aria-invalid') === 'true') check(el); });
      el.addEventListener('input', function () { if (el.getAttribute('aria-invalid') === 'true') check(el); });
    });
    cf.addEventListener('submit', function (e) {
      var errs = [], sum = $('#errsum');
      $$('input:not([type=hidden]),textarea', cf).forEach(function (el) { var m = check(el); if (m) errs.push('<li><a href="#' + el.id + '">' + m + '</a></li>'); });
      if (errs.length) {
        e.preventDefault();
        $('ul', sum).innerHTML = errs.join(''); sum.hidden = false; sum.focus();
        return;
      }
      sum.hidden = true;
      var btn = $('button[type=submit]', cf); btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Envoi en cours…';
    });
    if ($('#errsum')) $('#errsum').addEventListener('click', function (e) { var a = e.target.closest('a'); if (!a) return; e.preventDefault(); var t = $(a.getAttribute('href')); if (t) t.focus(); });
  }
  $$('[data-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var txt = b.getAttribute('data-copy'), lab = b.textContent;
      function done(m) { b.textContent = m; setTimeout(function () { b.textContent = lab; }, 1800); }
      function sel() { var c = $('code', b.parentNode); if (c) { var r = doc.createRange(); r.selectNodeContents(c); var s = getSelection(); s.removeAllRanges(); s.addRange(r); } done('Sélectionnée, faites Ctrl+C'); }
      try { navigator.clipboard.writeText(txt).then(function () { done('Adresse copiée'); }, sel); } catch (er) { sel(); }
    });
  });

  // ===== Sommaire automatique des articles =====
  var at = $('[data-auto-toc]');
  if (at) {
    var hs = $$('.sz-rte h2'), ol = $('ol', at);
    if (!hs.length) at.hidden = true;
    hs.forEach(function (h, i) {
      if (!h.id) h.id = 's-' + (i + 1) + '-' + h.textContent.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
      var li = doc.createElement('li'), a = doc.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); ol.appendChild(li);
    });
  }
  // ===== Sommaire : rubrique en cours =====
  var tocLinks = $$('.toc a[href^="#"]');
  if (tocLinks.length && 'IntersectionObserver' in window) {
    var secs = tocLinks.map(function (a) { return $(a.getAttribute('href')); }).filter(Boolean);
    var tio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) tocLinks.forEach(function (a) { a.classList.toggle('on', a.getAttribute('href') === '#' + e.target.id); }); });
    }, {rootMargin: '-20% 0px -70% 0px'});
    secs.forEach(function (s) { tio.observe(s); });
  }

  // ===== Site vivant =====
  if (!reduce && 'IntersectionObserver' in window) {
    var h1 = $('h1[data-words]');
    if (h1) {
      h1.innerHTML = h1.textContent.split(' ').map(function (w) { return '<span class="w">' + w + '</span>'; }).join(' ');
      h1.classList.add('pre');
      $$('.w', h1).forEach(function (w, i) { w.style.transitionDelay = (i * 70) + 'ms'; });
      requestAnimationFrame(function () { requestAnimationFrame(function () { h1.classList.remove('pre'); }); });
    }
    var word = $('.end .word');
    if (word) {
      word.innerHTML = word.textContent.split('').map(function (c) { return '<span class="l">' + c + '</span>'; }).join('');
      $$('.l', word).forEach(function (l, i) { l.style.transitionDelay = (i * 45) + 'ms'; });
      word.classList.add('pre');
    }
    // Citations mot par mot quand elles arrivent à l'écran
    $$('[data-words-io]').forEach(function (q) {
      q.innerHTML = q.textContent.split(' ').map(function (w) { return '<span class="w">' + w + '</span>'; }).join(' ');
      $$('.w', q).forEach(function (w, i) { w.style.transitionDelay = (i * 40) + 'ms'; });
      q.classList.add('pre');
    });
    var groups = ['.head2', '.callouts li', '.specs > div', '.vrow figure', '.moment', '.levels div', '.rv-card', '.faq .qa details', '.facts-co > div', '.incl > div',
                  '.rows > div', '.pos figure', '.steps li', '.prose > section', '.cmp-wrap', '.figpair figure', '.panel-legend li', '.story-p blockquote', '.story-p .col section', '.pcard', '.hub-list li'];
    var vh = innerHeight;
    groups.forEach(function (sel) {
      var n = 0;
      $$(sel).forEach(function (el) {
        if (el.classList.contains('rv')) return;
        if (el.getBoundingClientRect().top > vh) { el.classList.add('rv', 'pre'); el.style.transitionDelay = (n++ % 6) * 60 + 'ms'; }
        else el.classList.add('in');
      });
    });
    var rio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.classList.remove('pre'); el.classList.add('in');
        $$('[data-count]', el).forEach(count);
        if (el.matches('[data-count]')) count(el);
        rio.unobserve(el);
      });
      setTimeout(sweep, 30);
    }, {rootMargin: '0px 0px -10% 0px'});
    $$('.rv.pre, [data-io], .end .word, .specs, .heat .big, [data-words-io]').forEach(function (el) { rio.observe(el); });
    // Frise de Noël tracée à l'arrivée
    var tlL = $('[data-timeline]');
    if (tlL) { var tio2 = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { tlL.classList.add('seen'); tick(); tio2.disconnect(); } }, {threshold: .5}); tio2.observe(tlL); }
    // Panneau des boutons : pression à tour de rôle, légende synchronisée
    var pb = $$('.panel .b'), pl = $$('.panel-legend li'), pi = 0;
    if (pb.length) {
      var press = function () {
        var w = $('.panel-wrap'); if (w && w.classList.contains('paused')) return;
        pb.forEach(function (b, k) { b.classList.remove('press'); void b.offsetWidth; if (k === pi) b.classList.add('press'); });
        pl.forEach(function (l, k) { l.classList.toggle('on', k === pi); });
        pi = (pi + 1) % pb.length;
      };
      press(); setInterval(press, 2600);
    }
    // Barre de lecture de l'article
    var rb = $('.readbar i');
    if (rb) { var rp = function () { var m = root.scrollHeight - innerHeight; rb.style.transform = 'scaleX(' + (m > 0 ? Math.min(1, scrollY / m) : 0) + ')'; }; addEventListener('scroll', rp, {passive: true}); rp(); }
    var sweeping = false;
    function sweep() { $$('.rv.pre').forEach(function (el) { if (el.hidden) return; var r = el.getBoundingClientRect(); if (r.top < innerHeight) { el.classList.remove('pre'); el.classList.add('in'); } }); }
    addEventListener('scroll', function () { if (sweeping) return; sweeping = true; requestAnimationFrame(function () { sweeping = false; sweep(); }); }, {passive: true});
    addEventListener('hashchange', function () { setTimeout(sweep, 60); });
    addEventListener('load', function () { setTimeout(sweep, 60); });
    doc.addEventListener('visibilitychange', function () { if (!doc.hidden) setTimeout(sweep, 60); });
    setTimeout(sweep, 400);
    $$('.js-stars .stars').forEach(function (s) { $$('svg', s).forEach(function (v, i) { v.style.transitionDelay = (i * 90) + 'ms'; }); });
    function count(el) {
      if (el.dataset.done) return; el.dataset.done = 1;
      var to = +el.dataset.count, from = el.dataset.from ? +el.dataset.from : 0, t0 = performance.now(), d = 900;
      (function step(now) { var k = Math.min(1, (now - t0) / d); k = 1 - Math.pow(1 - k, 3);
        el.textContent = Math.round(from + (to - from) * k); if (k < 1) requestAnimationFrame(step); })(t0);
    }
    var anat = $('.anat');
    if (anat) {
      $$('.callouts li', anat).forEach(function (li) {
        function lp(on) { $$('[data-pin="' + li.dataset.pin + '"]', anat).forEach(function (x) { x.classList.toggle('on', on); }); }
        li.addEventListener('mouseenter', function () { lp(true); });
        li.addEventListener('mouseleave', function () { lp(false); });
      });
    }
    var lv = $$('.levels div'), li2 = 0;
    if (lv.length) { lv[0].classList.add('on'); setInterval(function () { var h = $('.heat'); if (h && h.classList.contains('paused')) return; lv[li2].classList.remove('on'); li2 = (li2 + 1) % lv.length; lv[li2].classList.add('on'); }, 2600); }
    var live = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('paused', !e.isIntersecting); }); });
    $$('.hero, .pdp, .anat, .offer, .heat, .reviews, .phead, .panel-wrap').forEach(function (s) { live.observe(s); });
  } else {
    $$('.levels div').forEach(function (d, i) { if (i === 0) d.classList.add('on'); });
    $$('.cmp-wrap, .steps li').forEach(function (x) { x.classList.add('in'); });
    var tl0 = $('[data-timeline]'); if (tl0) { tl0.classList.add('seen'); tick(); }
  }

  // ===== Menu : se cache quand on descend, réapparaît dès que l'on remonte =====
  var hd = $('.head');
  if (hd) {
    var ly = scrollY, tk = false;
    addEventListener('scroll', function () {
      if (tk) return; tk = true;
      requestAnimationFrame(function () {
        tk = false; var y = scrollY;
        if (y > 160 && y > ly + 6 && !openEl) hd.classList.add('hide');
        else if (y < ly - 6 || y < 160) hd.classList.remove('hide');
        ly = y;
      });
    }, {passive: true});
    hd.addEventListener('focusin', function () { hd.classList.remove('hide'); });
  }

  // ===== Barre « Voir l'offre » =====
  var bar = $('#obar');
  if (bar && 'IntersectionObserver' in window) {
    var watch = $$('[data-obar-hide], form[data-offer], .end, footer'), seen = new Map();
    function upd() {
      var any = false; seen.forEach(function (v) { if (v) any = true; });
      var on = scrollY > innerHeight * 0.6 && !any && !openEl;
      bar.classList.toggle('show', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); bar.tabIndex = on ? 0 : -1;
    }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { seen.set(e.target, e.isIntersecting); }); upd(); }, {threshold: .05});
    watch.forEach(function (el) { seen.set(el, false); io.observe(el); });
    addEventListener('scroll', upd, {passive: true});
  }
})();
